// extracted by mini-css-extract-plugin
module.exports = {"image":"CarouselImages_image__39Apd","h1":"CarouselImages_h1__1rmFZ","text":"CarouselImages_text__3yZsk","h2":"CarouselImages_h2___DdEt"};